module.exports = __webpack_public_path__ + "static/media/SST_industria_mineria.d26c17a4.png";